import { makeStyles } from '@material-ui/core/styles';
import { SOURCES }  from '../../../../../constants/sources';

export default makeStyles((theme) => ({
    rootBase: {
        width: '288px',
        minWidth: '288px',
        height: '315px',
        [theme.breakpoints.down('xs')]: {
            width: '224px',
            minWidth: '224px',
            height: '245px',
        }
    },
    [`logoCompany${SOURCES.UERRE}`]: {
        height: '19px',
        [theme.breakpoints.down('xs')]: {
            height: '16px',
        }
    },
    [`logoCompany${SOURCES.UNID}`]: {
        height: '22px',
        [theme.breakpoints.down('xs')]: {
            height: '19px',
        }
    },
    dataContainer: {
        padding: '40px 16px 0 16px',
        height: '273px',
        [theme.breakpoints.down('xs')]: {
            padding: '30px 12px 0 12px',
            height: '213px',
        }
    },
    priceAndMembershipContainer: {
        height: '42px',
        [theme.breakpoints.down('xs')]: {
            height: '32px',
        }
    },
    misCursosFillSVGIcon : {
        width: '28px',
        height: '28px',
        color: theme.palette.colors.grey[100],
    },
    programName: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        
        display: '-webkit-box !important',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        whiteSpace: 'normal',
    },
}));